import React, { Component } from "react";
import PropTypes from "prop-types";
import { Highlight, connectAutoComplete } from "react-instantsearch-dom";
import AutoSuggest from "react-autosuggest";
import CustomHighlight from "./Highlight";
import { Input, List, Avatar, Row, Col,Tag } from "antd";
import "../topHeader.css";
import { Link } from "react-router-dom";
const { Search } = Input;

class AutoComplete extends Component {
  static propTypes = {
    hits: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentRefinement: PropTypes.string.isRequired,
    refine: PropTypes.func.isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    onSuggestionCleared: PropTypes.func.isRequired
  };

  state = {
    value: this.props.currentRefinement
  };

  onChange = (_, { newValue }) => {
    if (!newValue) {
      this.props.onSuggestionCleared();
    }

    this.setState({
      value: newValue
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.props.refine(value);
  };

  onSuggestionsClearRequested = () => {
    this.props.refine();
  };

  getSuggestionValue(hit) {
 
    return hit.fullName || '';
  }

  renderSuggestion(hit) {
    return <CustomHighlight hit={hit} attribute="name" />;
  }

  render() {
    const { hits, onSuggestionSelected } = this.props;
    const { value } = this.state;

    const inputProps = {
      placeholder: "Search for  students or faculty..",
      onChange: this.onChange,
      value
    };

    const renderInputComponent = inputProps => (
      <Col span={24}>
        <Search
          className="searchDashboard"
          size="large"
          allowClear
          placeholder="Search People & Skills..etc"
          enterButton
          {...inputProps}
        />
      </Col>
    );

    function renderSuggestionsContainer({ containerProps, children, query }) {
      
      return (
        <div {...containerProps}>
          {/* {children &&           <List
    itemLayout="horizontal"
    dataSource={children.props.items}
    renderItem={item => (
      <List.Item>
        <List.Item.Meta
          avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
          title={<a href="https://ant.design">{item.name}</a>}
          description="Ant Design, a design language for background applications, is refined by Ant UED Team"
        />
      </List.Item>
    )}
  />} */}

          {children &&
            children.props.items.map(child => (
              <Link to={`/home/profile/${child.UID}`}><div className="autoCompleteItem">
                <Row className="autoCompleteItemhovernow">
                  <Col xs={0} sm={0} md={2} lg={2} xl={2} >
                    <Avatar
                      size={44}
                      style={{ backgroundColor: "#87d068" }}
                      icon="user"
                    />
                  </Col>
                  <Col xs={24} sm={24} md={22} lg={22} xl={22}>
            <div style={{fontSize:16,fontWeight:400}}>{child.fullName && child.fullName}</div>
                    <div style={{fontSize:14,marginTop:6}} >
                      <Tag  style={{marginRight:5,marginBottom:5}}color="geekblue">{child.role && child.role}</Tag>
                      <Tag style={{marginRight:5,marginBottom:5}} color="gold">{child.rollnumber && child.rollnumber}</Tag>
                      <Tag style={{marginRight:5,marginBottom:5}} color="purple">{child.gradYear && child.gradYear}</Tag>
                      <Tag style={{marginRight:5,marginBottom:5}} color="#2db7f5">{child.campus && child.campus}</Tag>
                      <Tag style={{marginRight:5,marginBottom:5}} color="#108ee9">{child.branch && child.branch}</Tag>
                      <Tag style={{marginRight:5,marginBottom:5}} color="#87d068">{child.email && child.email}</Tag>
                      </div>
                    
                  </Col>
                </Row>
              </div></Link>
            ))}
        </div>
      );
    }

    return (
      <AutoSuggest
        suggestions={hits}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        renderInputComponent={renderInputComponent}
        inputProps={inputProps}
        renderSuggestionsContainer={renderSuggestionsContainer}
      />
    );
  }
}

export default connectAutoComplete(AutoComplete);
